import { ele, HandlebarsHelper } from "cables-shared-client";
import PageOp from "./pages/ops/page_op.js";
import PageHome from "./pages/page_home.js";
import PagePatch from "./pages/patches/page_patch.js";
import PageError from "./pages/page_error.js";
import ProjectSettings from "./pages/patches/page_projectsettings.js";
import PageChangelog from "./pages/page_changelog.js";
import PageTest from "./pages/tests/page_test.js";
import PageTests from "./pages/tests/page_tests.js";
import PageTestRun from "./pages/tests/page_test_run.js";
import PageTestResult from "./pages/tests/page_test_result.js";
import PageActivityFeed from "./pages/user/page_activityfeed.js";
import PageMyFavs from "./pages/user/page_myfavs.js";
import PageMyPatches from "./pages/user/page_mypatches.js";
import PageMyData from "./pages/user/page_settings_mydata.js";
import PageProfileSettings from "./pages/user/page_settings_profile.js";
import PageUser from "./pages/user/page_user.js";
import PageTeam from "./pages/teams/page_team.js";
import PageTeamSettings from "./pages/teams/page_team_settings.js";
import PageTeamTodos from "./pages/teams/page_team_todos.js";
import PageTeamCreate from "./pages/teams/page_team_create.js";
import PageOpDelete from "./pages/ops/page_op_delete.js";
import PageOpEdit from "./pages/ops/page_op_edit.js";
import PageOpRename from "./pages/ops/page_op_rename.js";
import PageAssetDelete from "./pages/assets/page_asset_delete.js";
import PageAssetDependencies from "./pages/assets/page_asset_dependencies.js";
import PagePatchDependencies from "./pages/assets/page_patch_dependencies.js";
import PageExamples from "./pages/page_examples.js";
import PageTags from "./pages/page_tags.js";
import PageProjectExport from "./pages/page_project_export.js";
import PageMadeWithCables from "./pages/page_made_with_cables.js";
import PageLanding from "./pages/page_landing.js";
import PageBrowser from "./pages/page_browser.js";
import PageBrowserEvents from "./pages/page_browserevents.js";
import PageSearch from "./pages/page_search.js";
import PageErrorReport from "./pages/page_error_report.js";
import PageAdminMaintenance from "./pages/admin/page_admin_maintenance.js";
import PageAdminActivity from "./pages/admin/page_admin_activity.js";
import PageAdminNotifications from "./pages/admin/page_admin_notifications.js";
import PageAdminOps from "./pages/admin/page_admin_ops.js";
import PageAdminUser from "./pages/admin/page_admin_user.js";
import PageAdminUsers from "./pages/admin/page_admin_users.js";
import PageNamespaceDelete from "./pages/namespaces/page_namespace_delete.js";
import PageNamespaceEdit from "./pages/namespaces/page_namespace_edit.js";
import PageNamespace from "./pages/namespaces/page_namespaces.js";
import PagePatchlistEdit from "./pages/patchlists/page_patchlist_edit.js";
import web from "./web.js";
import PagePatchlist from "./pages/patchlists/page_patchlist.js";
import PageOpsChangelog from "./pages/ops/page_ops_changelog.js";
import PageAdminPatchlists from "./pages/admin/page_admin_patchlists.js";
import PageMyPatchLists from "./pages/user/page_mypatchlists.js";
import PagePatchlistsPublic from "./pages/patchlists/page_patchlists_public.js";
import PageBrowserSpeed from "./pages/page_browserspeed.js";
import PageAdminTeams from "./pages/admin/page_admin_teams.js";
import PageAdminBackups from "./pages/admin/page_admin_backups.js";

window.ele = ele;
document.addEventListener("DOMContentLoaded", () =>
{
    HandlebarsHelper.initHandleBarsHelper();
    const envEle = ele.byId("environmentVars");
    if (envEle)
    {
        web.init(envEle.dataset.loggedin, envEle.dataset.env, envEle.dataset.title);
    }
    else
    {
        web.init();
    }
    window.web = web;

    const pageLoaders = {
        "pageOp": PageOp,
        "pageHome": PageHome,
        "pagePatch": PagePatch,
        "pageError": PageError,
        "pageProjectSettings": ProjectSettings,
        "pageChangelog": PageChangelog,
        "pageTest": PageTest,
        "pageTests": PageTests,
        "pageTestRun": PageTestRun,
        "pageTestResult": PageTestResult,
        "pageActivityFeed": PageActivityFeed,
        "pageMyFavs": PageMyFavs,
        "pageMyPatches": PageMyPatches,
        "pageMyPatchLists": PageMyPatchLists,
        "pageMyData": PageMyData,
        "pageProfileSettings": PageProfileSettings,
        "pageUser": PageUser,
        "pageTeam": PageTeam,
        "pageTeamSettings": PageTeamSettings,
        "pageTeamTodos": PageTeamTodos,
        "pageTeamCreate": PageTeamCreate,
        "pageOpDelete": PageOpDelete,
        "pageOpEdit": PageOpEdit,
        "pageOpRename": PageOpRename,
        "pageOpsChangelog": PageOpsChangelog,
        "pageAssetDelete": PageAssetDelete,
        "pageAssetDependencies": PageAssetDependencies,
        "pagePatchDependencies": PagePatchDependencies,
        "pageExamples": PageExamples,
        "pageTags": PageTags,
        "pageProjectExport": PageProjectExport,
        "pageMadeWithCables": PageMadeWithCables,
        "pageLanding": PageLanding,
        "pageBrowser": PageBrowser,
        "pageBrowserEvents": PageBrowserEvents,
        "pageBrowserSpeed": PageBrowserSpeed,
        "pageSearch": PageSearch,
        "pageAdminActivity": PageAdminActivity,
        "pageAdminBackups": PageAdminBackups,
        "pageErrorReport": PageErrorReport,
        "pageAdminMaintenance": PageAdminMaintenance,
        "pageAdminNotifications": PageAdminNotifications,
        "pageAdminOps": PageAdminOps,
        "pageAdminPatchlists": PageAdminPatchlists,
        "pageAdminUser": PageAdminUser,
        "pageAdminUsers": PageAdminUsers,
        "pageAdminTeams": PageAdminTeams,
        "pageNamespaceDelete": PageNamespaceDelete,
        "pageNamespaceEdit": PageNamespaceEdit,
        "pageNamespace": PageNamespace,
        "pagePatchlistEdit": PagePatchlistEdit,
        "pagePatchlist": PagePatchlist,
        "pagePatchlistsPublic": PagePatchlistsPublic
    };

    const usedPageLoaders = ele.byQueryAll("[data-page-load]");
    usedPageLoaders.forEach((loaderElement) =>
    {
        const loaderName = loaderElement.dataset.pageLoad;
        if (pageLoaders[loaderName])
        {
            window.page = new pageLoaders[loaderName](loaderElement, web);
            window[loaderName] = window.page;
        }
        else
        {
            console.error("page loader not found for:", loaderName);
        }
    });

    const loadElements = ele.byQueryAll("[data-element-load]");
    loadElements.forEach((targetElement) =>
    {
        web.executeFunctionByName(targetElement.dataset.elementLoad, window, targetElement);
    });

    web.tabs.init();
    web.tables.init();
    web.cookies.showWarning();
    document.dispatchEvent(new Event("cablesWebReady"));
});

window.addEventListener("beforeunload", () =>
{
    web.isOnBeforeUnload = true;
});
export default web;
